var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAddToKbAppsIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 14.938c-.317-1.042-2.449-2.261-6.152-2.43a.937.937 0 0 1-.88-.94V3.223a.938.938 0 0 1 1.005-.937c.622.03.74.098 1.354.202M8 14.938c.317-1.042 2.449-2.261 6.152-2.43a.937.937 0 0 0 .88-.941V3.223a.937.937 0 0 0-1.005-.937c-.595.029-.688.091-1.276.187M8 12.313v2.625"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.66 4.585a3.58 3.58 0 1 0-5.012 3.277V8.88a.716.716 0 0 0 .716.716h1.432a.716.716 0 0 0 .716-.716V7.863a3.581 3.581 0 0 0 2.149-3.278ZM6.646 7.808h2.865M8.08 9.598v1.074"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddToKbAppsIcon);
export default __webpack_public_path__ + "static/media/add-to-kb-apps-icon.7c8ab99c1a5405103bc52196ce1ee5da.svg";
export { ForwardRef as ReactComponent };